// JsFromRoutes CacheKey b7e727b05a8ec0aa0e4054a5578f5fc3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/api/workspace/:venue_slug/deal_types'),
}
